import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _inherits from "@swc/helpers/src/_inherits.mjs";
import _wrap_native_super from "@swc/helpers/src/_wrap_native_super.mjs";
import _create_super from "@swc/helpers/src/_create_super.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext } from "react";
var ContextConsumedWithoutProviderError = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(ContextConsumedWithoutProviderError, Error1);
    var _super = _create_super(ContextConsumedWithoutProviderError);
    function ContextConsumedWithoutProviderError(message) {
        _class_call_check(this, ContextConsumedWithoutProviderError);
        var _this;
        _this = _super.call(this, "! ".concat(message, " was consumed without a provider"));
        _this.name = "ContextConsumedWithoutProviderError";
        return _this;
    }
    return ContextConsumedWithoutProviderError;
}(_wrap_native_super(Error));
export var createContextHook = function(param) {
    var defaultValue = param.defaultValue, displayName = param.displayName;
    var context = /*#__PURE__*/ createContext(defaultValue);
    context.displayName = displayName;
    return [
        {
            Consumer: function(param) {
                var children = param.children;
                return /*#__PURE__*/ _jsx(context.Consumer, {
                    children: function(value) {
                        if (value === undefined) {
                            throw new ContextConsumedWithoutProviderError(displayName);
                        }
                        return children(value);
                    }
                });
            },
            Provider: function(param) {
                var children = param.children, value = param.value;
                return /*#__PURE__*/ _jsx(context.Provider, {
                    value: value,
                    children: children
                });
            },
            displayName: displayName
        },
        function() {
            var value = useContext(context);
            if (value === undefined) {
                throw new ContextConsumedWithoutProviderError(displayName);
            }
            return value;
        }, 
    ];
};
